<template>
  <b-dropdown text="Marketplace"
              variant="light"
              menu-class="keyword-dropdown"
              :disabled="loading"
  >
    <template #button-content>
      <div v-if="selectedMarketplace">
        <span :class="`flag-icon flag-icon-${selectedMarketplace.value} mr6`"> </span>
        {{ selectedMarketplace.text }}
      </div>
      <div class="justify-content-between d-flex" v-else>
        <span class="mt-1">
                    {{ $t('pages.keyword.keyword_input.marketplace_placeholder') }}
        </span>
        <span v-if="invalid"> <i class="font-size-17 text-danger mdi mdi-alert-circle-outline"></i></span>
      </div>
    </template>

    <template v-for="(marketplace, index) in marketplaces">
      <b-dropdown-item :key="index" @click="setMarketplace(marketplace)" :active="selectedMarketplace === marketplace">
        <span :class="`flag-icon flag-icon-${marketplace.value} mr6`"> </span>
        {{ marketplace.text }}
      </b-dropdown-item>
    </template>
  </b-dropdown>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "KeywordMarketplace",
  props: {
    loading: {
      default: false
    },
    invalid: {
      default: false
    }
  },
  data() {
    return {
      selectedMarketplace: null,
      locationCodes: {
        "ATVPDKIKX0DER": "2840",
        "A2Q3Y263D00KWC": "2076",
        "A2EUQ1WTGCTBG2": "2124",
        "A1AM78C64UM0Y8": "2484",
        "A2VIGQ35RCS4UG": "2784",
        "A1PA6795UKMFR9": "2276",
        "A1RKKUPIHCS9HS": "2724",
        "A13V1IB3VIYZZH": "2250",
        "A1F83G8C2ARO7P": "2826",
        "A21TJRUUN4KGV": "2356",
        "APJ6JRA9NG5V4": "2380",
        "A1805IZSGTT6HS": "2528",
        "A1C3SOZRARQ6R3": "2616",
        "A17E79C6D8DWNP": "2682",
        "A2NODRKZP88ZB9": "2752",
        "A33AVAJ2PDY3EV": "2792",
        "A19VAU5U5O7RUS": "2702",
        "A39IBJ37TRP1C6": "2036",
        "A1VC38T7YXB528": "2392",
        "ARBP9OOSHTCHU": "2818"
      }
    }
  },
  methods: {
    setMarketplace(marketplace) {
      this.selectedMarketplace = marketplace
      marketplace.location_code = this.locationCodes[marketplace.marketplace_id]

      this.$emit('selected', {
        marketplace_id: marketplace.marketplace_id,
        location_code: this.locationCodes[marketplace.marketplace_id]
      })
    }
  },
  computed: {
    ...mapGetters('marketplaces', ['marketplaces']),
  }
}
</script>

<style scoped>
.invalid-dropdown {
  border: red !important;
}
</style>